import { render } from "./CardAvatar.vue?vue&type=template&id=40ec1b1e"
import script from "./CardAvatar.vue?vue&type=script&lang=js"
export * from "./CardAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/CardAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40ec1b1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40ec1b1e', __exports__)) {
    api.reload('40ec1b1e', __exports__)
  }
  
  module.hot.accept("./CardAvatar.vue?vue&type=template&id=40ec1b1e", () => {
    api.rerender('40ec1b1e', render)
  })

}


export default __exports__